export default "__VITE_ASSET__D9G4Epnw__"